import React from 'react';
import {
	Box,
	CircularProgress,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import './EmployeeHomeWidgets.scss';

interface EmployeeWidgetCardProps {
	title: string;
	headerExtra?: React.ReactNode;
	loading: boolean;
	colSpan: number;
	emptyMessage: string;
	isEmpty: boolean;
	header: React.ReactNode;
	children: React.ReactNode;
}

const EmployeeWidgetCard = ({
	title,
	headerExtra,
	loading,
	colSpan,
	emptyMessage,
	isEmpty,
	header,
	children,
}: EmployeeWidgetCardProps) => (
	<TableContainer component={Paper} className="employee-widget-card" elevation={0}>
		<Box className="employee-widget-header">
			<Typography variant="h6" className="employee-widget-title">
				{title}
			</Typography>
			{headerExtra ? <Box className="employee-widget-header-extra">{headerExtra}</Box> : null}
		</Box>
		<Box className="employee-widget-table-scroll">
			<Table stickyHeader className="employee-widget-table" size="small">
				<TableHead>{header}</TableHead>
				<TableBody>
					{loading ? (
						<TableRow>
							<TableCell colSpan={colSpan} align="center" sx={{ py: 6 }}>
								<CircularProgress size={20} />
							</TableCell>
						</TableRow>
					) : isEmpty ? (
						<TableRow>
							<TableCell colSpan={colSpan} align="center">
								<div className="employee-widget-empty">{emptyMessage}</div>
							</TableCell>
						</TableRow>
					) : (
						children
					)}
				</TableBody>
			</Table>
		</Box>
	</TableContainer>
);

export default EmployeeWidgetCard;
